const messageFieldData = {
  TRANSACTION_AMOUNT: '001',
  REFUND_CODE: '0150',
};

export { messageFieldData };
